/**
 * B_GridMovable.js
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/grid/B_GridMovable.js
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define         from 'canvas/base/dev/util/B_Define';

const B_GridMovable = (function(superclass){

    const $ = {
		_rotate : null,
	    _moveStatue : null,
	    _arrAction : null
    }

	class B_GridMovable extends superclass {

		constructor(obj) {
		    super(obj);

			// [S]
			this._rotate = (obj.rotate ? obj.rotate : B_Define.DEFAULT_ROTATE);
			this._moveStatus = false;
			// this._arrAction = [];
		}

		// [V]

		get _rotate() { return $._rotate; };
		set _rotate(r) {
			// [E]
			r = this._setSpecialRotate(r);
			// [S]
			$._rotate = r;
			this._selectMotion(r, 'stand')
		}

        // [F] protected

		/**
		 * @DES :: 특별각도[90, 180, 270, 360]로 설정하기
		 * @IP1 :: rot {num}
		 */
		_setSpecialRotate(rot) {
			if(rot > 360) rot -= 360;
			if(rot <= 0)  rot += 360;
			return rot;
		}

		/**
		 * @DES :: 움직임 상태체크 (어떤 행동 전에 사용)
		 * @IP1 :: cb {func}
		 */
		_checkMoveStatus(cb) {
			if(this._moveStatus) {
				return;
			} else {
				this._moveStatus = true;
				cb();
			}
		}

		/**
		 * @DES :: Grid 타입의 게임에서 상하좌우에 따른 액션값을 리턴해주는 함수입니다.
		 * @IP1 :: rot {num}
		 * @IP2 :: act {str}
		 * @O.P :: act {str}
		 */
		_getSelectMotion(rot, act) {
			switch (rot) {
				case 90:
					return act + "Right";
					break;
				case 180:
					return act + "Bottom";
					break;
				case 270:
					return act + "Right";
					break;
				case 360:
					return act + "Top";
					break;
			}
		}

		/**
		 * @DES :: 움작임 설정
		 * @IP1 :: rot {num}
		 * @IP2 :: act {str}
		 */
		_selectMotion(rot, act) {
			this._setSelectScaleX(rot);

			if (this._strResType == B_Define.ARR_RES_TYPE[2])
				this._object.gotoAndPlay(this._getSelectMotion(rot, act));
		}

		/**
		 * @DES :: 좌/우 케이스에 scaleX 반전시키기
		 * @IP1 :: rot {num}
		 * @S.E ::
		 */
		_setSelectScaleX(rot) {
			switch (rot) {
				case 90:
					this._scaleX = Math.abs(this._scaleX);
					break;
				case 180:
					this._scaleX = Math.abs(this._scaleX);
					break;
				case 270:
					this._scaleX = Math.abs(this._scaleX) * -1;
					break;
				case 360:
					this._scaleX = Math.abs(this._scaleX);
					break;
			}
		}

		/**
		 * @DES :: 움직임 사전처리
		 * @IP1 :: distance {num} - 움직일 거리
		 * @IP2 :: crushObject {arr} - 충돌 객체 모음
		 * @IP3 :: cb {func}
		 */
		_preMove(distance, crushObject, cb) {

			// [#] 가상 이동 (앞으로)
			for(let i=0; i<distance; i++) { this._locateFrontGrid(this._rotate); }
			this._checkCrush(crushObject, (boolCrush, CRUSH_PATH, CRUSH_OBJECT, CRUSH_VIRTUAL) => {

				// [#] 가상 이동 (뒤로)
				for (let i=0; i<distance; i++) { this._locateFrontGrid(this._setSpecialRotate(this._rotate - 180)); }

				// [#] goto-presentMove
				cb(boolCrush, CRUSH_PATH, CRUSH_OBJECT, CRUSH_VIRTUAL);
			});
		}

		/**
		 * @DES :: 움직임 현재처리
		 * @IP1 :: boolCrush {bool}
		 * @IP2 :: distance {num}
		 * @IP3 :: action {str}
		 * @IP4 :: cb {func}
		 */
		_presentMove(boolCrush, distance, action, cb){
			try {
				/**
				 * [STEP]
				 * 01. 성공/실패 여부 확인
				 * 02. 움직일 거리 위치 측정
				 * 03. 가상 움직임 배열에 추가 (성공시처리)
				 * 04. 각각 애니메이션 처리
				 * */

				if (!boolCrush) {
					// [#] 01. 성공

					// # 02.
					let fPixel = this._getFrontPixel(this._rotate, distance);
					let fGrid  = this._getFrontGrid(this._rotate, distance);

					// # 03.
					if(this.CODMOS.WORLD.addVirtual)
						this.CODMOS.WORLD.addVirtual(this._id, this._type, fGrid[0], fGrid[1]);


					// # 04.
					this.CODMOS.ANIMATE._tween.move(
						this,
						this._getSelectMotion(this._rotate, action),
						fPixel[0],
						fPixel[1],
						(tween) => {
							moveEnd(fPixel[0], fPixel[1]);
							if(this.CODMOS.WORLD.removeVirtual)
								this.CODMOS.WORLD.removeVirtual(this.id);
							cb();
						});
				}
				else {
					// [#] 01. 실패
					let fPixel = this._getFrontPixel(this._rotate, distance);
					let bPixel = [this._pixelX, this._pixelY];

					// # 04.
					this.CODMOS.ANIMATE._tween.crush(
						this,
						this._getSelectMotion(this._rotate, action),
						(fPixel[0] + bPixel[0]) / 2,
						(fPixel[1] + bPixel[1]) / 2,
						bPixel[0],
						bPixel[1],
						(tween) => {
							moveEnd(bPixel[0], bPixel[1]);
							cb();
						});
				}

				let moveEnd = (x, y) => {
					this._setGridXWithPixel(Math.ceil(x / this._gridDisX));
					this._setGridYWithPixel(Math.ceil(y / this._gridDisY));
				}
			} catch (e) {
				console.log(e);
			}
		}

		// [F] public

		moveForward(arrCrushObject, cb) {
			/**
			 * [STEP]
			 *
			 * 01. checkMoveStatus :: 이동상태 확인
			 * 02. preMove :: 앞에 충돌 여부 테스트
			 * 03. presentMove :: 실제 움직임 애니메이션
			 * */

			// /*[T]*/ console.log('moveForward');

			// [#] 행동 상태값 확인
			this._checkMoveStatus(() => {

				// [#] 이동위치 정보 확인
				this._preMove(B_Define.MOVE_DISTANCE/*1*/, arrCrushObject, (boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL) => {

					// [T]
					// console.log(boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL);

					// [#] 충돌 여부 확인
					const CRUSH_STATUS =
						boolCrushOut // FALSE - 충돌이면 안됨
						||
						!ARR_CRUSH_PATH[0] // TRUE - 충돌이여야 됨
						||
						ARR_CRUSH_OBJECT[0] // FALSE - 충돌이면 안됨
						||
						ARR_CRUSH_VIRTUAL[0]; // FALSE - 충돌이면 안됨

					// [#] 이동
					this._presentMove( CRUSH_STATUS, B_Define.MOVE_DISTANCE/*1*/, B_Define.ACTION_MOVE/*move*/, () => {

						cb(boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL);
					});
				});
			})
		}

		movePortal() {
		}

		moveTop(cb) {
			if(!this._moveStatus) {
				this._rotate = 360;
				this.moveForward(cb);
			}
		}

		moveDown(cb) {
			if(!this._moveStatus) {
				this._rotate = 180;
				this.moveForward(cb);
			}
		}

		moveRight(cb) {
			if(!this._moveStatus) {
				this._rotate = 90;
				this.moveForward(cb);
			}
		}

		moveLeft(cb) {
			if(!this._moveStatus) {
				this._rotate = 270;
				this.moveForward(cb);
			}
		}

		jumpForward(arrCrushObject, cb) {
			/**
			 * [STEP]
			 * 01. 이동상태 확인
			 * 02. checkFrontType :: 한칸 앞에 충돌 여부 테스트
			 * 03. preMove :: 두칸 앞에 충돌 여부 테스트
			 * 04. presentMove :: 실제 움직임 애니메이션
			 * 05. 충돌상태 확인
			 * 06. postMove :: 움직임 완료후에 연계 동작 처리
			 * */

			// [#] 행동 상태값 확인
			this._checkMoveStatus(() => {

				// [#] 점프시 사이값
				const FRONT_ITEM = this.checkFrontType(B_Define.BG_TYPE, this._rotate);

				// /*[T]*/ console.log(FRONT_ITEM);
				if(!FRONT_ITEM) {

					// TODO...
					// CASE1 if(점프시사이값무시)
					// CASE2 if(점프시사이값필수)

					// [#] 진행종료 => 바로 앞칸에 아무것도 없을시에 (배경으로 간주)
					this.CODMOS.WORLD.STATE.going(B_Define.CLEAR_STATUS['FAIL'], B_Define.REASON["CRUSH"]);
					cb(true);
				}
				else {

					// [#] 이동위치 정보 확인
					this._preMove(B_Define.JUMP_DISTANCE/*2*/, arrCrushObject, (boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL) => {

						// [T]
						// console.log(boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL);

						// [#] 충돌 여부 확인
						const CRUSH_STATUS =
							boolCrushOut // FALSE - 충돌이면 안됨
							||
							!ARR_CRUSH_PATH[0] // TRUE - 충돌이여야 됨
							||
							ARR_CRUSH_OBJECT[0] // FALSE - 충돌이면 안됨
							||
							ARR_CRUSH_VIRTUAL[0]; // FALSE - 충돌이면 안됨

						// # 04.
						this._presentMove(CRUSH_STATUS, B_Define.JUMP_DISTANCE/*2*/, B_Define.ACTION_JUMP/*jump*/, (crush) => {

							cb(boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL);
						});
					})
				}
			});
		}

		jumpTop(cb) {
			if(!this._moveStatus) {
				this._rotate = 360;
				this.jumpForward(cb);
			}
		}

		jumpDown(cb) {
			if(!this._moveStatus) {
				this._rotate = 180;
				this.jumpForward(cb);
			}
		}

		jumpRight(cb) {
			if(!this._moveStatus) {
				this._rotate = 90;
				this.jumpForward(cb);
			}
		}

		jumpLeft(cb) {
			if(!this._moveStatus) {
				this._rotate = 270;
				this.jumpForward(cb);
			}
		}

		rotateRight(cb) {
			if(!this._moveStatus) {
				this._rotate = this._rotate + 90;
			}
			cb();
		}

		rotateLeft(cb) {
			if(!this._moveStatus) {
				this._rotate = this._rotate - 90;
			}
			cb();
		}

		rotateBack(cb) {
			if(!this._moveStatus) {
				this._rotate = this._rotate + 180;
			}
			cb();
		}


	}

	return B_GridMovable;
});

export default B_GridMovable;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/grid/B_GridMovable.js